import { render, staticRenderFns } from "./SaleHistory.vue?vue&type=template&id=07b3b4f4&"
import script from "./SaleHistory.vue?vue&type=script&lang=ts&"
export * from "./SaleHistory.vue?vue&type=script&lang=ts&"
import style0 from "./SaleHistory.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports